import axios from "axios";

export default {
    SearchWord: async function (word, callback, errCallback) {
        await axios.get('/words-helper/search?' + new URLSearchParams({
            word: word,
        }).toString(), {}, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! words helper - search word", error);
            errCallback(error)
        });
    },
    RandomWords: async function (callback, errCallback) {
        await axios.get('/words-helper/random', {}, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! words helper - random word", error);
            errCallback(error)
        });
    },
    GetFullWord: async function (word, callback, errCallback) {
        await axios.get('/words-helper/' + word, {}, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! words helper - get full word", error);
            errCallback(error)
        });
    },
    CheckWordSentence: async function (word, task, taskNum, userInput, audioBlob, voiceMode, callback, errCallback)  {
        await axios.postForm('/words-helper/check', {
            idx: taskNum,
            word: word,
            task: task,
            user_input: userInput,
            file_buffer: audioBlob,
            voice_mode: voiceMode,
        }, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! check word sentence", error);
            errCallback(error.response.data)
        });
    },
    GetWordHintWordSentence: async function (word, wordIdx, task, callback, errCallback)  {
        await axios.post('/words-helper/hint', {
            word: word,
            word_index: wordIdx,
            task: task,
        }, {
            withCredentials: true
        })
        .then(response => callback(response.data))
        .catch(error => {
            console.error("There was an error! get word hint for word", error);
            errCallback(error.response.data)
        });
    }
}

